var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_alert_error_outline_24px",
    "data-name": "icon/alert/error_outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 48,
    height: 48,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M21.978,44A22,22,0,1,1,44,22,22.014,22.014,0,0,1,21.978,44ZM22,4.4A17.6,17.6,0,1,0,39.6,22,17.62,17.62,0,0,0,22,4.4ZM24.2,33H19.8V28.6h4.4V33Zm0-8.8H19.8V11h4.4V24.2Z",
    transform: "translate(2 2)",
    fill: "#0062a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.7a96c254fc4b384354a5ce8a0de91095.svg";
export { ForwardRef as ReactComponent };